<template>
  <div v-if="data" id="idle" class="idle">
    <img src="@/assets/img/session-expires.svg?data" class="session" alt="Session warning" />
    <div class="clearfix"></div>
    <span class="text-center" v-html="data.error.sessionExpiredText"></span>
    <span class="text-center">{{ seconds }} {{ data.error.sessionExpiredDisclaimer }}</span>
  </div>
</template>

<script>
import { request } from '../plugins/datocms'
import { showDelayText } from '../plugins/delayhandler'
import config from '../../config/index.js'
import $ from 'jquery'

export default {
  name: 'session',
  data () {
    return {
      data: null,
      time: 30000 // 30 seconds (ms)
    }
  },
  computed: {
    seconds () {
      return this.time / 1000
    }
  },
  created () {
    this.setOpacities(true)
    let timerId = setInterval(() => {
      this.time -= 1000
      if (!this.$store.state.idleVue.isIdle) {
        this.setOpacities(false)
        clearInterval(timerId)
      }
      if (this.time < 1) {
        this.setOpacities(false)
        clearInterval(timerId)
        this.logOutUser()
      }
    }, 1000)
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          error(locale: ` + sessionStorage.getItem('language') + `) {
            sessionExpiredText
            sessionExpiredDisclaimer
          }
        }
      `
    })
  },
  methods: {
    setOpacities (state) {
      if (state) {
        $('#user, #footer, .navbar, .container').css('opacity', '0.2')
      } else {
        $('#user, #footer, .navbar, .container').css('opacity', '1.0')
      }
    },
    logOutUser () {
      let loader = this.$loading.show({
        default: showDelayText(config.delayText, config.delayTimer)
      })
      this.$store.commit('setLogin', false)
      this.$store.commit('setName', null)
      var cookies = localStorage.getItem('vue-cookie-accept-decline-cookies')
      var access = localStorage.getItem('access')
      var pharmacy = localStorage.getItem('pharmacy')
      localStorage.clear()
      sessionStorage.clear()
      if (cookies) localStorage.setItem('vue-cookie-accept-decline-cookies', cookies)
      if (access) localStorage.setItem('access', access)
      if (pharmacy) localStorage.setItem('pharmacy', pharmacy)
      loader.hide()
      window.location.href = window.location.origin.concat('/sessionexp')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#idle {
  position: fixed;
  margin-top: 5%;
  left: 50%;
  transform: translateX(-50%);
  background: #fff;
  z-index: 999;
}
.idle {
  height: 40vh;
  width: 80vh;
  border: 5px solid black;
  border-radius: 20px;
  padding: 5em;
}
.session {
  width: 60px;
  height: 60px;
}
/* Portrait and Landscape */
@media only screen
  and (min-device-width: 300px)
  and (max-device-width: 812px) {
  #idle {
    position: fixed;
    background: #fff;
    z-index: 999;
  }
  .idle {
    height: auto;
    width: 80vw;
    border: 5px solid black;
    border-radius: 20px;
    padding: 1em;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Session.vue